import { FC } from 'react';

import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PageviewIcon from '@mui/icons-material/Pageview';
import Button from '@mui/material/Button';
import ToolCard from 'components/ToolCard';

const HotelImportsCard: FC = () => (
  <ToolCard
    icon={<CloudDownloadIcon fontSize="large" />}
    title="Viešbučių importas"
    description="Žiūrėti viešbučių importo statistiką"
    action={
      <Button
        href="/tools/hotel-imports"
        startIcon={<PageviewIcon />}
        size="small">
        Žiūrėti
      </Button>
    }
  />
);

export default HotelImportsCard;
